var React = require('react');

function HtmlInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #028fc4;\n      }\n    ")),React.createElement("path",{"id":"Html.inline","className":"cls-1","d":"M1.5,0H82.843l-7.4,83.523-33.362,9.44L8.91,83.519ZM28.734,37.766l-.9-10.528L66.8,27.25l.891-10.156-51.037-.012,2.7,31.026H54.706l-1.263,13.27L42.171,64.493,30.725,61.355,30,53.182H19.891l1.278,16.156,21,5.616,20.835-5.589,2.882-31.6H28.734Z","transform":"translate(-1.5)","key":1})]);
}

HtmlInline.defaultProps = {"className":"icon","viewBox":"0 0 81.343 92.962"};

module.exports = HtmlInline;

HtmlInline.default = HtmlInline;
